import script from "./company-links-empty-state.vue?vue&type=script&setup=true&lang=ts"
export * from "./company-links-empty-state.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__